import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3A54255E-EDE1-4622-87F4-9FCB31B1B688
 * name label-variant
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/label-variant.svg
 * tags
 */
export const LabelVariantIcon = createSvgIcon(<><path d="M3.5,19L8.34,12L3.5,5H14.5C15.17,5 15.72,5.3 16.13,5.86L20.5,12L16.13,18.14C15.72,18.7 15.17,19 14.5,19H3.5Z" /></>, 'LabelVariantIcon');
export default LabelVariantIcon